import { IconButton, Tooltip } from '@mui/material'
import LinkIcon from '@mui/icons-material/LinkRounded'
import { intl } from '../../../../../i18n'

export interface Props {
  isSupportedURLCopy: () => boolean
  onClickUrlIcon: () => void
}

const SavedUIStateCopyUrlIconButton = ({
  isSupportedURLCopy,
  onClickUrlIcon,
}: Props) => {
  return (
    <Tooltip
      title={intl.formatMessage(
        { id: 'savedUIState.urlCopy' },
        {
          urlCopy: isSupportedURLCopy()
            ? ''
            : intl.formatMessage({
                id: 'unsupportedBrowser',
              }),
        }
      )}
    >
      <IconButton
        size={'small'}
        edge={'end'}
        aria-label={'copy-url'}
        onClick={onClickUrlIcon}
      >
        <LinkIcon
          color={'action'}
          sx={{
            width: '17px',
            transform: 'rotate(135deg)',
          }}
        />
      </IconButton>
    </Tooltip>
  )
}

export default SavedUIStateCopyUrlIconButton
